import { navigate } from '@mr-yum/frontend-core/dist/services/routes'
import { Button, ReceiptOutlineIcon } from '@mr-yum/frontend-ui'
import { useLogger } from 'hooks/useLogger'
import { OrderingTypeSlug, routes } from 'lib/routes'
import React, { useCallback, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  venueSlug: string
  orderingTypeSlug?: OrderingTypeSlug | undefined
  tabId?: string
  orderId?: string
  email?: string | null
  openDrawer?: () => void
}

export const ViewReceiptCTA = ({
  venueSlug,
  orderingTypeSlug,
  tabId,
  orderId,
  email,
  openDrawer,
}: Props) => {
  const loggerProps = useMemo(
    () => ({
      defaultProperties: { venueSlug, orderingTypeSlug, orderId, tabId },
    }),
    [venueSlug, orderingTypeSlug, orderId, tabId],
  )
  const { logEvent } = useLogger(loggerProps)

  const handleClick = useCallback(() => {
    logEvent('Click on view receipt from order confirmation page')

    if (email) {
      void navigate(routes.history, {
        venueSlug,
        goBack: true,
      })
    } else {
      openDrawer?.()
    }
  }, [logEvent, openDrawer, email, venueSlug])

  return (
    <Button
      type="button"
      onClick={handleClick}
      variant="secondary"
      size="sm"
      leftIcon={<ReceiptOutlineIcon />}
    >
      <FormattedMessage defaultMessage="View receipt" id="ZgS4SQ" />
    </Button>
  )
}
